import { createSlice } from "@reduxjs/toolkit";

export const stateSlice = createSlice({
  name: "witch",
  initialState: {
    magicalInsight: "",
    birthDate: {},
    birthPlace: "",
    birthTime: {},
    tradition: "",
    setSymbols: "",
    storm: "",
    nature: "",
    lineage: "",
    intuitiveHealing: "",
    intuition: "",
    energy: "",
    elements: "",
    crowdComfort: "",
    animals: "",
    ancestor: "",
  },
  reducers: {
    setMagicalInsight: (state, action) => {
      state.magicalInsight = action.payload;
    },
    setBirthDate: (state, action) => {
      state.birthDate = action.payload;
    },
    setBirthPlace: (state, action) => {
      state.birthPlace = action.payload;
    },
    setBirthTime: (state, action) => {
      state.birthTime = action.payload;
    },
    setTradition: (state, action) => {
      state.tradition = action.payload;
    },
    setSymbols: (state, action) => {
      state.setSymbols = action.payload;
    },
    setStorm: (state, action) => {
      state.storm = action.payload;
    },
    setNature: (state, action) => {
      state.nature = action.payload;
    },
    setLineage: (state, action) => {
      state.lineage = action.payload;
    },
    setIntuitiveHealing: (state, action) => {
      state.intuitiveHealing = action.payload;
    },
    setIntuition: (state, action) => {
      state.intuition = action.payload;
    },
    setEnergy: (state, action) => {
      state.energy = action.payload;
    },
    setElements: (state, action) => {
      state.elements = action.payload;
    },
    setCrowdComfort: (state, action) => {
      state.crowdComfort = action.payload;
    },
    setAnimals: (state, action) => {
      state.animals = action.payload;
    },
    setAncestor: (state, action) => {
      state.ancestor = action.payload;
    },
  },
});

export const {
  setMagicalInsight,
  setBirthDate,
  setBirthPlace,
  setBirthTime,
  setTradition,
  setSymbols,
  setStorm,
  setNature,
  setLineage,
  setIntuitiveHealing,
  setIntuition,
  setEnergy,
  setElements,
  setCrowdComfort,
  setAnimals,
  setAncestor,
} = stateSlice.actions;

export default stateSlice.reducer;
